import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthContext from "../providers/authProvider";
import Cookies from "js-cookie";
import { resolveNavigationPath } from "../providers/authProvider";

const CLUB_ROUTES = [
  '/club_admin/club',
  '/club_admin/',
  '/club_admin/teams',
  '/club_admin/users',
  '/club_admin/exercises',
  '/club_admin/exercise_collections',
  '/club_admin/actions',
  '/club_admin/lessons',
  '/club_admin/practice_templates',
  '/club_admin/subscriptions',
  '/club_admin/import_attempts'
];

const ORGANIZATION_ROUTES = [
  '/club_admin/organization',
  '/club_admin/clubs_organization',
  '/club_admin/members'
];

const getRouteType = (pathname) => {
  if (CLUB_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'))) { return 'club' }
  if (ORGANIZATION_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'))) { return 'organization' }

  return 'other';
};

const useRestoreEntity = (entity, cookieKey, setEntity, shouldRestore) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (shouldRestore && !entity) {
      const restore = async () => {
        setLoading(true);
        const savedId = Cookies.get(cookieKey);
        if (savedId && (!entity || entity.id !== parseInt(savedId))) {
          await setEntity();
        }
        setLoading(false);
      };
      restore();
    }
  }, [entity, cookieKey, setEntity, shouldRestore]);

  return loading;
};

const ClubRouteGuard = ({ children }) => {
  const { user, club, organization, organizations, clubsCount, setClub } = useAuthContext();
  const location = useLocation();
  const routeType = getRouteType(location.pathname);
  const loading = useRestoreEntity(club, "club_id", setClub, routeType === "club" && user);

  if (routeType !== "club") { return children }
  if (loading) return <div>Loading club...</div>;

  if (!club) {
    const redirectPath = resolveNavigationPath({
      user,
      current_club: club,
      current_organization: organization,
      managed_clubs_count: clubsCount,
      organizations_count: organizations,
    });
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};


const OrganizationRouteGuard = ({ children }) => {
  const { user, club, organization, organizations, clubsCount, setOrganization } = useAuthContext();
  const location = useLocation();
  const routeType = getRouteType(location.pathname);
  const loading = useRestoreEntity(organization, "organization_id", setOrganization, routeType === "organization" && user);

  if (routeType !== 'organization') { return children }
  if (loading) return <div>Loading organization...</div>;
  
  if (!organization) {
    const redirectPath = resolveNavigationPath({ 
      user,
      current_club: club,
      current_organization: organization,
      managed_clubs_count: clubsCount,
      organizations_count: organizations,
    });
    return <Navigate to={redirectPath} replace />;
  }
  
  return children;
};

export const RouteGuard = ({ children }) => {
  return (
    <ClubRouteGuard>
      <OrganizationRouteGuard>
        {children}
      </OrganizationRouteGuard>
    </ClubRouteGuard>
  );
};
